module.exports = __webpack_public_path__ + "img/milestone__1980.8ee2be92.jpg";